import { render, staticRenderFns } from "./MenuVert.vue?vue&type=template&id=8765258e&"
import script from "./MenuVert.vue?vue&type=script&lang=js&"
export * from "./MenuVert.vue?vue&type=script&lang=js&"
import style0 from "./MenuVert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports